import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Toasted from 'vue-toasted'
import App from './app'
import router from '@router'
import store from '@state/store'
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css'
import '@components/_globals'
import i18n from './locales'
import VueClipboard from 'vue-clipboard2'
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'
import find from 'lodash/find'
import '../node_modules/material-icons/iconfont/material-icons.scss'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import '@assets/css/quill-editor.css'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.prototype.moment = moment
// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}
Vue.filter('numFormat', numFormat(numeral))
Vue.filter('codeDecimal', (value, asset_code) => {
  if (!value) return ''
  const asset_info = find(store.state.assets.assets, {
    code: asset_code,
  }) || { decimal_point: 8 }
  const decimal = parseFloat(value).toFixed(asset_info.decimal_point)
  const parts = decimal.toString().split('.')
  const comma =
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (parts[1] ? '.' + parts[1] : '')

  return comma
})
Vue.filter('numberFormat', (value) => {
  const parts = value.split('.')
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (parts[1] ? '.' + parts[1] : '')
  )
})
Vue.filter('trimDecimalZero', (value) =>
  `${value}`.replace(/(?:\.0+|(\.\d+?)0+)$/, '$1')
)
Vue.use(VuejsDialog, {
  okText: '확인',
  cancelText: '취소',
})
Vue.use(Element, {
  locale,
})
Vue.use(Toasted, {
  duration: 5000,
  theme: 'bubble',
  icon: 'info_outline',
  fitToScreen: false,
  position: 'top-center',
  iconPack: 'material',
})
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)
const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

app.$i18n.locale = store.state.common.locale
